import { ArrowDown, MapPin } from "lucide-react";
import { motion } from "framer-motion";
import { useSite } from "@/context/SiteContext";
import { ServiceIcon } from "@/components/site/ServiceIcon";

const HeroVisual = () => (
  <div className="relative h-[210px] sm:h-[320px]" aria-hidden="true">
    <div className="absolute inset-[4%_4%_6%_14%] nn-blob bg-[#B8E1F7] rotate-[-8deg]" />
    <div className="absolute right-[8%] top-[2%] h-40 w-40 sm:h-56 sm:w-56 rounded-full border border-white/80" />
    <div className="absolute left-[30%] sm:left-[26%] top-5 h-40 w-40 sm:h-60 sm:w-60 rounded-[51%_49%_45%_55%] bg-white/95 shadow-[0_28px_60px_rgba(62,129,151,0.22)] grid place-items-center rotate-[4deg]">
      <img src="/logo-nanina.png" alt="" className="h-[74%] w-[74%] object-contain" />
    </div>
    <span className="absolute top-10 left-[14%] h-4 w-4 rounded-full bg-nanina-butter" />
    <span className="absolute bottom-8 right-[12%] h-3.5 w-3.5 rounded-full bg-nanina-peach" />
  </div>
);

export const Hero = () => {
  const { site, selectService } = useSite();
  const s = site.settings;
  const featured = site.categories.filter((c) => (s.featured_category_slugs || []).includes(c.slug));
  return (
    <section id="beranda" className="relative overflow-hidden border-b border-nanina-line bg-[linear-gradient(118deg,#F7FAFC_0%,#F3F9FB_50%,#E2F2FB_100%)]" data-testid="hero-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 grid md:grid-cols-[1.05fr_.95fr] items-center gap-4 md:gap-8 pt-9 pb-6 md:py-14">
        <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45 }}>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-nanina-green" data-testid="hero-eyebrow">
            <span className="h-2 w-2 rounded-full bg-nanina-fresh" /> {s.hero_eyebrow}
          </p>
          <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-[-0.04em] leading-[1.08] text-nanina-green max-w-xl" data-testid="hero-title">
            {s.hero_title}
          </h1>
          <p className="mt-4 text-sm sm:text-base text-nanina-muted max-w-md leading-relaxed" data-testid="hero-description">{s.hero_description}</p>
          <a href="#layanan" className="mt-6 inline-flex items-center gap-2 rounded-full bg-nanina-green text-white text-sm font-semibold px-6 py-3.5 hover:bg-nanina-greendark hover:-translate-y-0.5 transition-[transform,background-color] shadow-[0_12px_25px_rgba(49,95,82,0.2)]" data-testid="hero-cta-button">
            {s.hero_cta} <ArrowDown className="h-4 w-4" />
          </a>
          {featured.length > 0 && (
            <div className="mt-6 flex flex-wrap gap-2" data-testid="hero-featured-services">
              {featured.map((c) => (
                <a key={c.id} href="#layanan" onClick={() => selectService(c.id)} className="inline-flex items-center gap-1.5 rounded-full bg-white border border-nanina-line px-3 py-1.5 text-xs font-medium text-nanina-green hover:border-nanina-sky transition-colors" data-testid={`hero-featured-${c.slug}`}>
                  <ServiceIcon name={c.icon} className="h-3.5 w-3.5" /> {c.name}
                </a>
              ))}
            </div>
          )}
          <p className="mt-5 flex items-center gap-1.5 text-xs text-nanina-muted"><MapPin className="h-3.5 w-3.5 text-nanina-fresh" /> Giwangan, Umbulharjo, Yogyakarta</p>
        </motion.div>
        <HeroVisual />
      </div>
    </section>
  );
};
